import { useMemo } from 'react';
import { prop, path } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { useComponentConfig } from 'js/hooks/component';

import * as constants from '../constants';

export const useGetSportsbookConfig = () => {
    const lang = useUserSelector(prop('lang'));
    const userId = useUserSelector(path(['userDetails', 'username']));
    const { oddsType, sportsBookLayout, localeMap = [], defaultLocale } = useComponentConfig();

    return useMemo(() => {
        const locale = localeMap.find((item) => item.portal === lang)?.sportsbook || defaultLocale;

        return {
            ...locale ? { locale } : {},
            containerID: constants.SPORTSBOOK_HTML_CONTAINER_ID,
            ...userId ? { UserId: userId } : {},
            ...oddsType ? { oddsType } : {},
            ...sportsBookLayout ? { sportsBookLayout } : {}
        };
    }, [localeMap, defaultLocale, userId, oddsType, sportsBookLayout, lang]);
};
